var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.config.loginNoticeShowMode == "2" && _vm.config.loginNoticeContent
        ? _c("div", { staticClass: "notice-wrap" }, [
            _c(
              "div",
              {
                staticClass: "laba-wrap",
                style: { background: "#" + _vm.config.schemeColor }
              },
              [
                _c("img", {
                  staticClass: "notice-img",
                  attrs: { src: require("@/assets/img/laba.svg"), alt: "" }
                })
              ]
            ),
            _c("div", [_vm._v(_vm._s(_vm.config.loginNoticeContent))]),
            _c(
              "span",
              {
                staticClass: "watch",
                style: { color: "#" + _vm.config.schemeColor },
                on: { click: _vm.openNotice }
              },
              [_vm._v("查看")]
            )
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "notice-dialog-wrap",
          attrs: {
            "modal-append-to-body": "",
            "append-to-body": "true",
            visible: _vm.noticeDialogVisible,
            width: "450px",
            "before-close": _vm.closeNotice
          },
          on: {
            "update:visible": function($event) {
              _vm.noticeDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "notice-wrapper" },
            [
              _c("img", {
                staticClass: "notice-laba",
                attrs: { src: require("@/assets/img/laba.png"), alt: "" }
              }),
              _c("img", {
                staticClass: "notice-xuxian",
                attrs: { src: require("@/assets/img/xuxian.png"), alt: "" }
              }),
              _c("div", { staticClass: "notice-title" }, [_vm._v("通知公告")]),
              _c("el-scrollbar", [
                _c(
                  "div",
                  { staticClass: "content" },
                  _vm._l(_vm.loginNoticeContent, function(item, index) {
                    return _c("div", { key: index }, [_vm._v(_vm._s(item))])
                  }),
                  0
                )
              ]),
              _c(
                "div",
                { staticClass: "notice-btn" },
                [
                  _c(
                    "el-button",
                    {
                      style: {
                        color: "#" + _vm.config.schemeColor,
                        borderColor: "#" + _vm.config.schemeColor,
                        opacity: "0.8"
                      },
                      attrs: { size: "small", plain: "", round: "" },
                      on: {
                        click: function($event) {
                          _vm.noticeDialogVisible = false
                        }
                      }
                    },
                    [_vm._v("我知道了")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }